<div class="flex items-center justify-center  text-center text-gray-500 mt-3">
  <div>
    {{suggestText}}
    <a *ngIf="link" class="text-primary outline-none cursor-pointer" [routerLink]="link" (click)="btnClicked.emit()"> {{title}} </a>
    <div *ngIf="!link" class="text-primary outline-none cursor-pointer" (click)="btnClicked.emit()">{{title}}</div>
  </div>
</div>